export default "__VITE_ASSET__D_nAGg5X__"